/* Cart upsell quick-add */
(function () {
  function onAddClick(ev) {
    const btn = ev.target.closest('.cart-upsell__add');
    if (!btn || btn.disabled) return;
    const id = btn.dataset.addId;
    if (!id) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add';
      });
  }
  document.addEventListener('click', onAddClick);
})();
